import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, ListPagination } from '../../../components/UI/ComponentsUI';
import { translate, enumText } from '../../../utils/util';
import { ENUMS } from '../../../utils/constants'

const OrderGroupListItem = (props) => {
    const [currentPage, setCurrentPage] = useState(0);

    return (
        <div>
            <Breadcrumbs id="orderGroupsTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: `Chamadas Bloco ${props.group?.orderGroupId || ''}` }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div id="listGroupsItems">
                    <ListPagination
                        page={0}
                        current={{ currentPage, setCurrentPage }}
                        data={props.group?.orders?.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                            >
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {item?.orderCode || ''}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {item?.routeCode || ''}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {translate(`expedition:${enumText(ENUMS.eOrderStatus, item.status)}`)}
                                </span>
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        group: state.orderGroupReducer.orderGroup
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderGroupListItem)));

